import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { catalogProductFormStyles as styles } from './catalogProductForm.styles';

type Option<Value extends string> = {
  value: Value;
  label: string;
};

type Props<Value extends string> = {
  options: readonly Option<Value>[];
  value: Value;
  onChange: (value: Value) => void;
  testIDPrefix: string;
};

export function CatalogProductFormSegmentedRow<Value extends string>({
  options,
  value,
  onChange,
  testIDPrefix,
}: Props<Value>) {
  return (
    <View style={styles.formSegmentRow}>
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <TouchableOpacity
            key={option.value}
            style={[styles.formSegmentButton, selected && styles.formSegmentButtonActive]}
            onPress={() => onChange(option.value)}
            accessibilityRole="button"
            accessibilityLabel={option.label}
            accessibilityState={{ selected }}
            testID={`${testIDPrefix}.${option.value}`}
          >
            <Text style={[styles.formSegmentText, selected && styles.formSegmentTextActive]}>
              {option.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
}
